import React from 'react';
import { ConfigProvider, theme } from 'antd'
import deDE from 'antd/locale/de_DE';
import { useThemeStore } from 'shared-lib/state/theme.ts';

export function AntdThemeProvider({ children }: { children: React.ReactNode }) {
    const themeState = useThemeStore();

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#ffa200",
                },
                algorithm: themeState.theme === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm,
            }}
            locale={deDE}
        >
            {children}
        </ConfigProvider>
    )
}